import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import Inseriscidati from '../screens/Inseriscidati/Inseriscidati';
import Inseriscicard from '../screens/Inseriscicard/Inseriscicard';
import Login from '../screens/Login/Login';
import Confermail from '../screens/Confermail/Confermail';
import Userarea from '../screens/Userarea/Userarea';
import Haisbaglimail from '../screens/Haisbaglimail/Haisbaglimail';
import Termini from '../screens/Termini/Termini';
import Benvenuto from '../screens/Benvenuto/Benvenuto'
import Configminore from '../screens/Configminore/Configminore'
import Dovesciare from '../screens/Dovesciare/Dovesciare'
import Riepicarrello from '../screens/Riepicarrello/Riepicarrello'
import Ritirocard from '../screens/Ritirocard/Ritirocard'
import Indirizione from '../screens/Indirizione/Indirizione'
import Insericredito from '../screens/Insericredito/Insericredito'
import Recuperapass from '../screens/Recuperapass/Recuperapass'
import Acquistuato from '../screens/Acquistuato/Acquistuato'
import Caricaminore from '../screens/Caricaminore/Caricaminore'
import WelcomeScreen from '../screens/WelcomeScreen/WelcomeScreen'
import DeliveryMethod from '../screens/DeliveryMethod/DeliveryMethod'
import Cart from '../screens/Cart/Cart'
import CardActivation from '../screens/CardActivation/CardActivation'
import UserAddress from '../screens/UserAddress/UserAddress';
import PurchaseCompleted from '../screens/PurchaseCompleted/PurchaseCompleted';
import PageNotFound from '../screens/PageNotFound/PageNotFound';
import { isLogged } from './fetch';
//import GATest from '../screens/GATest/GATest'

class Routes extends Component {

	render() {
		return (
			<div>
				<div>
					<Switch>
						<Route exact path="/" component={isLogged() ? Userarea : Login} />
						{/* <Route exact path="/confirm-purchase" component={Acquistuato} /> */}
						<Route exact path="/credit-card" component={Insericredito} />
						<Route exact path="/Indirizione" component={Indirizione} />
						<Route exact path="/Ritirocard" component={Ritirocard} />
						<Route exact path="/cart" component={Cart} />
						{/* <Route exact path="/activate-card" component={Inseriscicard} /> */}
						<Route exact path="/resorts" component={Dovesciare} />
						<Route exact path="/config-card" component={Configminore} />
						<Route exact path="/signup" component={Inseriscidati} />
						<Route exact path="/confirm" component={Confermail} />
						<Route exact path="/userarea" component={Userarea} />
						<Route exact path="/resend-mail" component={Haisbaglimail} />
						<Route exact path="/terms" component={Termini} />
						<Route exact path="/upload" component={Caricaminore} />
						<Route exact path="/resend-password" component={Recuperapass} />
						<Route exact path="/WelcomeScreen" component={WelcomeScreen} />
						<Route exact path="/delivery-method" component={DeliveryMethod} />
						<Route exact path="/activate-card" component={CardActivation} />
						<Route exact path="/delivery-address" component={UserAddress} />
						<Route exact path="/transaction-confirm" component={PurchaseCompleted} />
						<Route component={PageNotFound} />
					</Switch>
				</div>
			</div>
		);
	}
}

export default Routes;


// WEBPACK FOOTER //
// ./src/libs/routes.js